/**
 * Filename: ShinQLoader.tsx
 * Description: Shared animated Shin Q loading indicator for the administration console.
 * Created by: Teddy Gil "Shin" Ravis Orbeta
 * Created: 2026-07-30
 * Updated: 2026-07-30
 */

import React from 'react';

interface ShinQLoaderProps {
  iconOnly?: boolean;
  label?: string;
  message?: string;
  size?: 'button' | 'compact' | 'page';
}

export function ShinQLoader({
  iconOnly = false,
  label = 'Loading',
  message,
  size = 'page',
}: ShinQLoaderProps) {
  return (
    <div className={`shin-q-loader shin-q-loader-${size}`} role="status" aria-live="polite">
      <span className="shin-q-loader-mark" aria-hidden="true">
        <img src={`${process.env.PUBLIC_URL}/shin-q-loader-base.png`} alt="" />
        <i />
        <i />
        <i />
      </span>
      <span className={size === 'button' || iconOnly ? 'visually-hidden' : undefined}>{message ?? label}</span>
    </div>
  );
}
